export class Project {

  debug: boolean;

  constructor() {
    this.debug = false;
  }
}
